/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'

export const useAddMediaTopic = (topicID: string) => {
  const axios = useContext(AxiosContext)
  return useMutation({
    mutationKey: [ReactQueryKeys.ADD_MEDIA_TOPIC, topicID],
    mutationFn: async (photos: string) => {
      const response = await axios.api.post('ajax/topics', {
        requestType: 'topicPhotoUpdate',
        'photoData[action]': 'add',
        'photoData[photoID][]': [photos],
        'photoData[scale]': 1,
        'photoData[seqnum]': 1,
        'photoData[topicID]': topicID,
        format: 'json',
      })
      return response
    },
  })
}
